class ImageGrid {
  constructor(el) {
    this.el = el;
    this.anchorsEl = this.el.querySelectorAll('[data-action-anchor]');
    this.anchorHeight = document.querySelector('header').offsetHeight;
    this.anchorSubMenu = document.querySelector('.anchor-menu');
    this.init();
  }

  init() {
    this.anchor();
  }

  anchor() {
    this.anchorsEl.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        let id = e.currentTarget.getAttribute('href');

        if (id.includes('#')) {
          id = id.substring(id.indexOf('#'));
        }

        const targetElement = document.querySelector(id);

        if (targetElement) {
          const offsetTop = document.querySelector(id).offsetTop;

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
            duration: 500,
          });
        }
      });
    });
  }
}

export default ImageGrid;
